import { AccessTime, Cancel, Close, DateRange, Event, ExpandMore } from "@mui/icons-material";
import {
  Autocomplete,
  Avatar,
  IconButton,
  TextField,
  Tooltip,
  Drawer,
  Box,
  Divider,
  Grid,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import moment from "moment";
import { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import dayjs from "dayjs";
import { base_url } from "services";
import colors from "assets/theme/base/colors";
import MDTypography from "components/MDTypography";
import { SelectEmployee } from "components/SelectEmployee";

export function LeaveHistoryComponent({
  permissions,
  modulePermissions,
  reload,
  setReload,
  employeeLeaveBalance,
  employee,
  leaveAdmin,
  adminFilters
}) {
  const user = JSON.parse(localStorage.getItem("user"));

  const [leaveStatus, setLeaveStatus] = useState("Pending");
  const [employeeStatus, setEmployeeStatus] = useState("Active");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"));
  const effectiveStatus = adminFilters?.status || leaveStatus;
  const effectiveEmployee = adminFilters?.employee || selectedEmployee;
  const effectiveManager = adminFilters?.manager || selectedManager;
  const effectiveMonth = adminFilters?.month || selectedMonth;
  const [leaveData, setLeaveData] = useState({
    columns: [
      {
        Header: "Name",
        accessor: "firstname",
        Cell: ({ row }) => (
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => handleNameClick(row.original)}
          >
            <MDTypography variant="body1" fontSize="14px" fontWeight="bold">
              {row.original?.firstname} {row.original?.lastname}
            </MDTypography>
          </div>
        ),
      },
      {
        Header: "Apply Date",
        accessor: "created_at",
        Cell: ({ row }) => moment(row.original.created_at).format("YYYY-MM-DD"),
      },
      { Header: "Start Date", accessor: "start_date" },
      { Header: "End Date", accessor: "end_date" },
      {
        Header: "Category",
        accessor: "category",
        Cell: ({ row }) => row.original?.leave_category?.name,
      },
      {
        Header: "Hours",
        accessor: "hours",
        Cell: ({ row }) => row.original.number_of_hours,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) =>
          //permissions?.includes(modulePermissions?.update_permission) ? (
          //  <Autocomplete
          //    blurOnSelect
          //    underlineShow={false}
          //    value={["pending", "approved", "rejected"].find(
          //      (e) => e == row.original.status
          //    )}
          //    options={["pending", "approved", "rejected"]}
          //    onChange={(event, newValue) => {
          //      changeStatus(row.original.id, newValue);
          //    }}
					//		sx={{background : colors.background.accent}}
          //    renderInput={(params) => (
          //      <TextField
          //        {...params}
          //        variant="standard"
          //        InputProps={{
          //          ...params.InputProps,
          //          disableUnderline: true,
          //        }}
          //        sx={{ width: "120px" }}
          //      />
          //    )}
          //  />
          //) : (
					<Chip
						label={row.original.status.toUpperCase()}
						sx={{
							mt: 1,
							backgroundColor: statusColors[row.original.status]?.background, // Set background color
							color: statusColors[row.original.status]?.text, // Set text color
							fontWeight: 'bold'
						}}
					/>
          //),
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) =>
          permissions?.includes(modulePermissions?.delete_permission) && (
            <Tooltip title="Cancel">
              <IconButton
                aria-label="cancel"
                size="small"
                onClick={() => deleteLeaveRequest(row.original.id)}
                disabled={
                  new Date() > new Date(row.original.start_date) &&
                  user?.employee_id  !== row.original.employee.hr_manager &&
                  user?.employee_id !== row.original.employee.manager
                }
              >
                <Cancel />
              </IconButton>
            </Tooltip>
          ),
      },
    ],
    rows: [],
  });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedEmployeeLeaveBalance, setSelectedEmployeeLeaveBalance] = useState(employeeLeaveBalance);

  useEffect(() => {
    getLeaveRequests();
  }, [reload, leaveStatus, employeeStatus, selectedEmployee, selectedManager, selectedMonth, leaveAdmin, adminFilters]);

  async function getLeaveRequests() {
    const params = new URLSearchParams();
    if (effectiveStatus && !["All", "all"].includes(effectiveStatus)) {
      params.append("status", effectiveStatus.toLowerCase());
    }
    if (employeeStatus && employeeStatus !== "All") {
      params.append("employee__status", employeeStatus.toLowerCase());
    }
    if (leaveAdmin) {
      if (effectiveEmployee) {
        params.append("employee", effectiveEmployee);
      }
      if (effectiveManager) {
        params.append("manager", effectiveManager);
      }
    }
    if (effectiveMonth) {
      const [year, month] = effectiveMonth.split("-");
      params.append("year", year);
      params.append("month", month);
    }
    var res = await ApiCalls.getLeaveRequest(`?${params.toString()}`);
    if (res.success && res.code == 200) {
      let updatedRows = res.data.map((e) => ({
        ...e,
        firstname: e.employee.user.firstname,
        lastname: e.employee.user.lastname,
      }))
       .sort((a, b) =>
     new Date(b.start_date) - new Date(a.start_date)
    )
      setLeaveData((prev) => ({ ...prev, rows: updatedRows }));
    }
  }

  async function changeStatus(id, status) {
    var payload = { status };
    var res = await ApiCalls.updateLeaveRequest(id, payload, false);
    if (res.success) {
      getLeaveRequests();
      setReload(Math.random().toString());
    }
  }

  async function deleteLeaveRequest(id) {
    var res = await ApiCalls.deleteLeaveRequest(id);
    if (res.success && res.code == 204) {
      getLeaveRequests();
      setReload(Math.random().toString());
    }
  }

  const handleNameClick = (row) => {
    setSelectedRow(row);
    getEmployeeLeaveBalance(row?.employee?.id);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedRow(null);
  };

  async function getEmployeeLeaveBalance(id) {
    var res = await ApiCalls.getEmployeeLeaveBalance(id);
    if (res.success && res.code == 200) {
      setSelectedEmployeeLeaveBalance(res.data);
    }
  }


  const statusColors = {
    pending: { background: "#FB8C00", text: "#FFF" }, 
    approved: { background: "#4CAF50", text: "#FFF" }, 
    rejected: { background: "#F44336", text: "#FFF" }, 
};

// Extract color settings based on status
const status = selectedRow?.status.toLowerCase();
const chipColors = statusColors[status] || { background: "#E0E0E0", text: "#000" };
  return (
    <MDBox 
		//sx={{background: `linear-gradient(135deg, ${colors.background.default} 0%, ${colors.background.accent} 100%)`,}}
		>
      <MDBox display="flex" justifyContent="left" alignItems="center" mb={2}>
        {/*<Autocomplete
          disablePortal
          fullWidth
					sx={{
						width: 300,
						marginRight: 2,
						//"& .MuiInputBase-root": {
						//	color: "#fff",
						//},

						//"& .MuiInputLabel-root": {
						//	color: "#aaa",
						//},
					}}
          options={["All", "Pending", "Approved", "Rejected"]}
          value={leaveStatus}
          onChange={(event, newValue) => setLeaveStatus(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Filter by Leave Status" variant="outlined" />
          )}
        />*/}

        {leaveAdmin && !adminFilters && (
          <>
            <SelectEmployee
              label="Employee"
              placeholder="Filter employee"
              onSelected={setSelectedEmployee}
            />
            <MDBox mr={2} />
            <SelectEmployee
              label="Manager"
              placeholder="Filter manager"
              onSelected={setSelectedManager}
            />
            <MDBox mr={2} />
            <TextField
              type="month"
              label="Month"
              value={selectedMonth}
              onChange={(event) => setSelectedMonth(event.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ width: 180, marginRight: 2 }}
            />
          </>
        )}

        {permissions?.employee?.includes("update") && 
				<Autocomplete
          disablePortal
          fullWidth
          sx={{ width: 300, marginRight: 2 }}
          options={["All", "Active", "Deactive"]}
          value={employeeStatus}
          onChange={(event, newValue) => setEmployeeStatus(newValue)}
          renderInput={(params) => (
            <TextField {...params} label="Filter by Employee Status" variant="outlined" />
          )}
        />}

      </MDBox>

      <DataTable table={leaveData} canSearch/>

      {/* Drawer for Employee Details */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{ sx: { width: 350, padding: 2, margin : '0px', height:'100%', borderRadius : '0px' } }}
      >
        <Box sx={{
          p: 2,
          height: "100%",
          overflow: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          "-ms-overflow-style": "none",
          "scrollbar-width": "none"
        }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <MDTypography variant="h6" fontWeight="bold">
              Leave Details
            </MDTypography>
            <IconButton onClick={handleCloseDrawer}>
              <Close />
            </IconButton>
          </Box>

          {selectedRow && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <Avatar alt="Profile Photo" sx={{ width: 70, height: 70 }}>
                  <img
                  src={`${base_url}${selectedRow?.employee?.img}`}
                  style={{ width: "70px", height: "70px", objectFit: "cover", borderRadius: "50%" }}
                />
                </Avatar>
                <Box>
                  <MDTypography variant="h6" fontWeight="bold">
                    {selectedRow.firstname} {selectedRow.lastname}
                  </MDTypography>
                  <Chip
                    label={selectedRow.status.toUpperCase()}
                    sx={{
                        mt: 1,
                        backgroundColor: chipColors.background, // Set background color
                        color: chipColors.text, // Set text color
                        fontWeight : 'bold'
                    }}
                  />
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              {selectedRow && <Box> 
                <MDTypography variant="h6">Available Balances</MDTypography>
                <Box display='flex' justifyContent='space-between'>
                  <Box display='flex' flexDirection='column' alignItems='center'>
                    <MDTypography variant="h6" fontSize='16px'>{selectedEmployeeLeaveBalance?.casual_leave}</MDTypography>
                    <MDTypography >Casual Leaves</MDTypography>
                  </Box>
                  <Box display='flex' flexDirection='column' alignItems='center'>
                    <MDTypography variant="h6" fontSize='16px'>{selectedEmployeeLeaveBalance?.un_paid}</MDTypography>
                    <MDTypography >Unpaid Leaves</MDTypography>
                  </Box>
                </Box>
              </Box>
              }

              <Divider sx={{ my: 2 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Event fontSize="12px" />
                  <Box>
                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Start Date</MDTypography>
                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.start_date}</MDTypography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Event fontSize="12px" />
                  <Box>
                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>End Date</MDTypography>
                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.end_date}</MDTypography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <AccessTime fontSize="12px" />
                  <Box>
                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Total Hours</MDTypography>
                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.number_of_hours}</MDTypography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <DateRange fontSize="12px" />
                  <Box>
                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Applied On</MDTypography>
                    <MDTypography variant="body2" fontSize='12px'>{dayjs(selectedRow.created_at).format("YYYY-MM-DD")}</MDTypography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <DateRange fontSize="12px" />
                  <Box>
                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Status</MDTypography>
                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.status}</MDTypography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <DateRange fontSize="12px" />
                  <Box>
                    <MDTypography variant="body1" fontSize='14px' fontWeight='600px'>Category</MDTypography>
                    <MDTypography variant="body2" fontSize='12px'>{selectedRow.leave_category?.name}</MDTypography>
                  </Box>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              <Accordion sx={{ marginTop: "14px",background : `linear-gradient(180deg, ${colors.light.main} 0%, ${colors.background.accent} 100%)`}}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <MDTypography variant="h6" fontSize="16px" fontWeight="600">
                                Leaves Transactions
                            </MDTypography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {selectedRow?.transactions ? (
                                selectedRow?.transactions?.map((txn) => (
                                    <Box key={txn.leave_request} sx={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
                                        <Box display='flex' justifyContent='space-between'>
                                        <MDTypography variant="body1" fontSize="14px" fontWeight="600">
                                            {moment(txn.transaction_date).format("YYYY-MM-DD")}
                                        </MDTypography>
                                        <MDTypography variant="body1" fontSize="14px" fontWeight="600">
                                            {txn?.leave_request}
                                        </MDTypography>
                                        </Box>
                                        <Grid container spacing={2} sx={{ marginTop: "4px" }}>
                                            <Grid item xs={4}>
                                                <MDTypography variant="body2" fontSize="12px" color="gray">
                                                    Old Balance
                                                </MDTypography>
                                                <MDTypography variant="body1" fontSize="14px">{txn.old_balance}</MDTypography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <MDTypography variant="body2" fontSize="12px" color="gray">
                                                    New Balance
                                                </MDTypography>
                                                <MDTypography variant="body1" fontSize="14px">{txn.new_balance}</MDTypography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <MDTypography variant="body2" fontSize="12px" color="gray">
                                                    Leaves Taken
                                                </MDTypography>
                                                <MDTypography variant="body1" fontSize="14px">{txn.old_balance - txn.new_balance}</MDTypography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))
                            ) : (
                                <MDTypography variant="body1" fontSize="14px">
                                    No transactions available.
                                </MDTypography>
                            )}
                        </AccordionDetails>
                    </Accordion>
            </>
          )}
        </Box>
      </Drawer>
    </MDBox>
  );
}
